import { render, staticRenderFns } from "./ListBrand.vue?vue&type=template&id=ce8b61d4&"
import script from "./ListBrand.vue?vue&type=script&lang=js&"
export * from "./ListBrand.vue?vue&type=script&lang=js&"
import style1 from "./ListBrand.vue?vue&type=style&index=1&id=ce8b61d4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports